import Bridge from "./services/Bridge";

export default async function () {
    const bridge = new Bridge();

    // listen for the initialize-wizard-settings event
    bridge.on("initialize-wizard-settings", async (payload) => {
        let index = await import("./Index");
        index.default.init(bridge, payload);
    });

    window.initBuilder = async function (payload) {
        let index = await import("./Index");
        index.default.init(bridge, payload);
    };

    window.enableTestingMode = async function () {
        let index = await import("./Index");
        index.default.enableTestingMode(bridge);
    };

    // tell the parent window that the wizard bridge is initialized
    bridge.fire("wizard-bridge-initialized", {});
}
